module.exports = __webpack_public_path__ + "img/IMG_1401_L.bd6764e1.webp";